import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ApexFields as ApexFields$1 } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var BlockApexFields = function BlockApexFields(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    _ref$innerBlocks = _ref.innerBlocks,
    innerBlocks = _ref$innerBlocks === void 0 ? [] : _ref$innerBlocks;
  return /*#__PURE__*/React.createElement(ApexFields$1, _extends({
    key: index
  }, attrs), generateBlockList({
    blocks: innerBlocks
  }));
};
BlockApexFields.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape({}),
  innerBlocks: PropTypes.array
} : {};
var ApexFields = BlockApexFields;

export { ApexFields as default };
